import { useTranslation } from "react-i18next";
import "./Login.css";
import logoIcon from "../../base/assets/icons/logo.svg";
import { Modal, Typography, Grid, TextField } from "@mui/material";
import Button from "../../base/reusables/button/Button";
import ModalButton from "../../base/reusables/button/Button";
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import AppStore from "../../base/stores/AppStore";
import UserStore from "../../base/stores/UserStore";
import { useNavigate } from "react-router-dom"; import { checkLoginWithoutRedirect } from "../../base/services/loginService";
import { validateEmail } from "./Validation";
import CustomModal from "../../base/modal/Modal";

// Styled components
const ModalContent = styled("div")({
  position: "absolute",
  paddingTop: "77px",
  height: "254px",
  width: "512px",
  backgroundColor: "rgba(255, 255, 255, 1)",
  borderRadius: "13px 13px 0 0",
  boxShadow: "0 25px 31px 0 rgba(0, 0, 0, 0.2)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderBottomLeftRadius: "50% 40px !important",
  borderBottomRightRadius: "50% 40px !important",
  "@media (max-width: 600px)": {
    width: "80vw",
  },
});

const ModalBackdrop = styled("div")({
  backgroundColor: "rgba(0, 15, 30, 0.81)",
  "& div:first-child": {
    backgroundColor: "unset !important",
  },
});

const Title = styled(Typography)({
  textAlign: "center",
  fontFamily: "FbReforma",
  fontSize: "25px",
  color: "rgba(40, 40, 40, 1)",
  letterSpacing: "0px",
  marginBottom: "41px",
  "@media (max-width: 600px)": {
    fontSize: "16px",
  },
});

const ForgotPassword: React.FC = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [email, setEmail] = useState<string>("");
  const [isLoggedIn, setIsLoggedin] = useState<boolean>(false);
  const [error, setError] = useState("");
  useEffect(() => {
    checkUserLogin();
  }, []);

  const setFocus = (errors: any) =>
    document.getElementById(errors[0].props.id)?.focus();

  const checkUserLogin = async () => {
    try {
      const { token } = await checkLoginWithoutRedirect();
      if (token) {
        setErrorMessage(t("User-logged-in-error"));
        setModalOpen(true);
        setIsLoggedin(true);
        return;
      }
    } catch (error: any) {
      if (error.statusCode < 400) {
        setErrorMessage(error.errorMessages);
      } else {
        setErrorMessage(t("GeneralError"));
      }
      setModalOpen(true);
    }
  };

  const handleSubmit = async (e: React.SyntheticEvent) => {

    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (!email) {
    //   setError(t("Validation-Required"));
    //   return;
    // }
    // if (!emailRegex.test(email)) {
    //   setError(t("Validation-InvalidEmail"));
    //   return;
    // }
    e.preventDefault();
    let errorEmail = validateEmail(email, t);

    if (errorEmail != '') {
      setError(errorEmail);
    }
    else {

      try {
        AppStore.incrementLoadingProcedure();
        await UserStore.sendForgotPasswordOtp(email);
        navigate("/one-time-password/forgotPassword");
      } catch (error: any) {
        if (error.statusCode < 400) {
          setErrorMessage(error.errorMessages);
        } else {
          setErrorMessage(t("GeneralError"));
        }
        setModalOpen(true);
      } finally {
        AppStore.decrementLoadingProcedure();
      }
    }
 

  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    let errorEmail = validateEmail(e.target.value, t);

    if (errorEmail != '') {
      setError(errorEmail);
    }
    else {
    setError("");
    }
  };

  const redirect = () => {
    setModalOpen(false);
    navigate(`${isLoggedIn ? "/" : "/login"}`);
  };

  return (
    <>
      {!isLoggedIn && (
        <div className={'background'}>
          <div className={'wrapper'}>
            <div className={'resetPassBox'}>
              <img
                tabIndex={0}
                className={'logo'}
                width="152"
                src={logoIcon}
                alt={t("Header-Logo-alt")}
              />
              <h3 className={'header'}>{t("Forgot-password-header")}</h3>
              <span>{t("Reset-password-set-email-to-reset")}</span>
              <form >

                <Grid container>
                  <Grid className={'register__field'} xs={12} sm={8} item>
                    <TextField
                      onChange={handleEmailChange}
                      value={email}
                      name="email"
                      fullWidth
                      id="email"
                      variant="standard"
                      className="custom-text-field"
                      style={{ direction: "ltr" }}
                      label={t("Login-mail")}
                      error={!!error}
                      helperText={error  && t("Validation-InvalidEmail")}
                    />
                  </Grid>
                  <Grid className={'resetPassButton'} xs={12} sm={4} item>
                    <Button type="submit" aria-label={t("Reset-password-send")} onClick={handleSubmit}>
                      {t("Reset-password-send")}
                    </Button>
                  </Grid>
                </Grid>
              </form>


              {/* <ValidatorForm
                onSubmit={handleSubmit}
                onError={(errors) => setFocus(errors)}
              >
                <Grid container>
                  <Grid className={'register__field} xs={12} sm={8} item>
                    <TextValidator
                      onChange={handleEmailChange}
                      value={email}
                      name="email"
                      fullWidth
                      id="email"
                      style={{ direction: "ltr" }}
                      label={t("Login-mail")}
                      
                      validators={["required", "isEmail"]}
                      errorMessages={[t("Validation-Required"), t("Validation-InvalidEmail")]}
                    />
                  </Grid>
                  <Grid className={'resetPassButton} xs={12} sm={4} item>
                    <Button type="submit" aria-label={t("Reset-password-send")}>
                      {t("Reset-password-send")}
                    </Button>
                  </Grid>
                </Grid>
              </ValidatorForm> */}
            </div>
          </div>
        </div>
      )}
         <CustomModal
        text={errorMessage}
        isOpen={modalOpen}
        handleModalStatus={(isOpen) => setModalOpen(isOpen)}
        onClose={redirect}
      />
      {/* <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={modalOpen}
        onClose={redirect}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 15, 30, 0.81)",
          },
        }}
      >
        <ModalContent>
          <Title variant="h6" id="modal-title">
            {errorMessage}
          </Title>
          <ModalButton aria-label={errorMessage} onClick={redirect}>
            {t("got-it")}
          </ModalButton>
        </ModalContent>
      </Modal> */}
    </>
  );
};

export default ForgotPassword;
